import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { GenericService } from '../service/generic.service';
import { Store } from '@ngxs/store';
import { ObjectUtils } from '@cv-invision/core';
import { GenericEditableTableComponent } from '../generic-editable-table/generic-editable-table.component';

@Component({
	selector: 'cv-generic-mapper-types',
	templateUrl: '../../components/tables/editable-table/editable-table.component.html',
	providers: [ConfirmationService, MessageService]
})
export class GenericMapperTypesComponent extends GenericEditableTableComponent implements OnInit, OnChanges {

	public model: Array<any> = [
		{
			label: 'Integration Id',
			key: 'key'
		},
		{
			label: 'Integration Label',
			key: 'label'
		},
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
			],
			onChange: ($event: any, row: any) => {
				if ($event.value === 'Acuity') {
					this.model[3].options = this.acuityOptions;
				} else {
					this.model[3].options = this.appScopeOptions;
				}

				if (this.model[3].options[0]) {
					const selectedValue = this.model[3].options[0];

					this.data[row.id] = { ...row, ...{trackingSystemId: selectedValue.value, trackingSystemLabel: selectedValue.label} };
				}
			}
		},
		{
			label: 'Tracking System Option',
			key: 'trackingSystemId',
			type: 'select',
			options: [],
			onChange: ($event: any, row: any) => {
				let selectedValue = [];

				if (row.trackingSystem === 'Acuity') {
					selectedValue = this.acuityOptions.filter(option => option.value === $event.value);
				} else {
					selectedValue = this.appScopeOptions.filter(option => option.value === $event.value);
				}

				if (selectedValue.length) {
					this.data[row.id] = { ...row, ...{trackingSystemId: selectedValue[0].value, trackingSystemLabel: selectedValue[0].label} };
				}
			},
			getValue: (field: any, row: any) => {
				return row['trackingSystemLabel'];
			}
		},
		{
			label: 'Tracking System Id',
			key: 'trackingSystemId',
			disabled: true
		},
		{
			label: 'Tracking System Label',
			key: 'trackingSystemLabel',
			disabled: true
		}
	];

	public tmpModel: Array<any> = [];

	public data: Array<any> = [];

	public appScopeOptions: Array<any>;
	public acuityOptions: Array<any>;

	constructor(
		public confirmationService: ConfirmationService,
		public messageService: MessageService,
		protected service: GenericService,
		private store: Store,)
	{
		super(confirmationService, messageService, service);
	}

	ngOnInit(): void {
		const entity = `mappers/${this.entity}`;
		this.service.setConfiguration(this.integrationId, entity);

		this.label = this.entity.replace(/([A-Z])/g, ' $1').trim();
		this.setOptions();

		this.model = this.model.map((tmpModel) => {
			return {...this.defaultModel, ...tmpModel}
		});

		this.tmpModel = [...this.model];

		this.loadData();
	}

	setOptions(): void {
		if (this.entity !== 'OnHoldReason') {

			if (this.tmpModel.length) {
				this.model = [...this.tmpModel];
			}

			let appScopes = [];
			let type  = this.entity.charAt(0).toLocaleLowerCase() + this.entity.slice(1);
			appScopes = this.store.selectSnapshot((state: any) => ObjectUtils.getStateFromString(state, `globalConfiguration.appScope.${type}`));
	
			this.appScopeOptions = appScopes.map((appScope: any) => {
				return {
					label: appScope.name,
					value: appScope.id,
				}
			});
	
			let acuities = [];
			acuities = this.store.selectSnapshot((state: any) => ObjectUtils.getStateFromString(state, `globalConfiguration.acuity.${type}`));
	
			this.acuityOptions = acuities.map((acuity: any) => {
				return {
					label: acuity.name,
					value: acuity.id,
				}
			});
		} else if (this.entity === 'OnHoldReason') {
			let tmpModel = [...this.tmpModel];
			tmpModel[4] = {...tmpModel[4], ...{disabled: false}};
			tmpModel[5] = {...tmpModel[5], ...{disabled: false}};
			
			tmpModel = tmpModel.filter((model)=> model.label != 'Tracking System Option');

			this.model = [...tmpModel];
		}
	}

	onRowEditInit(row: any): void {
		const entity = `mappers/${this.entity}`;
		this.service.setConfiguration(this.integrationId, entity);

		if (row.trackingSystem === 'Acuity') {
			this.model[3].options = this.acuityOptions;
		} else {
			this.model[3].options = this.appScopeOptions;
		}

		this.clonedData[row.id] = { ...row };
	}

	/**
	 * Detect changes on values variable in order to option selected
	 * @param changes 
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes['entity'].currentValue !== changes['entity'].previousValue) {
			const entity = `mappers/${this.entity}`;
			this.service.setConfiguration(this.integrationId, entity);
			this.label = this.entity.replace(/([A-Z])/g, ' $1').trim();
			this.setOptions();
			this.loadData();
		}
	}
}
